import React, { useEffect, useState } from 'react';
import { MapPin, Phone, Mail, MessageCircle, Loader2, Save, Check } from 'lucide-react';
import { adminApi } from '../lib/api';

const ContactSettings = () => {
  const [form, setForm] = useState({ contact_address: '', contact_maps_url: '', contact_phone: '', contact_email: '', contact_whatsapp: '' });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    adminApi.getContactSettings().then((s) => { setForm(s); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  const save = async () => {
    setSaving(true); setMessage('');
    try {
      const s = await adminApi.updateContactSettings(form);
      setForm(s);
      setMessage('Coordonnées enregistrées');
      setTimeout(() => setMessage(''), 3000);
    } catch (e) {
      setMessage("Erreur : " + (e?.response?.data?.detail || e.message));
    } finally { setSaving(false); }
  };

  if (loading) return <div className="p-8 flex justify-center"><Loader2 className="w-6 h-6 animate-spin text-[#F4A340]" /></div>;

  const field = (icon, label, key, placeholder, type = 'text') => {
    const Icon = icon;
    return (
      <div>
        <label className="block text-sm font-semibold text-slate-700 mb-2 flex items-center gap-2">
          <Icon className="w-4 h-4 text-[#E89534]" /> {label}
        </label>
        <input
          data-testid={`contact-${key.replace('contact_', '')}`}
          type={type}
          placeholder={placeholder}
          value={form[key] || ''}
          onChange={(e) => setForm({ ...form, [key]: e.target.value })}
          className="w-full px-4 py-2.5 rounded-xl border-2 border-slate-200 focus:border-[#F4A340] outline-none text-sm"
        />
      </div>
    );
  };

  return (
    <div className="space-y-4" data-testid="contact-settings">
      <div>
        <h3 className="text-lg font-bold text-slate-900">Coordonnées de contact</h3>
        <p className="text-sm text-slate-500">Ces informations sont affichées dans le menu, le footer et sur la fiche de contact du site</p>
      </div>

      <div className="bg-white rounded-2xl border border-slate-200 p-6 space-y-4">
        {field(MapPin, 'Adresse', 'contact_address', 'FJ98+J3F, Porto-Novo, Bénin')}
        {field(MapPin, 'Lien Google Maps', 'contact_maps_url', 'https://maps.google.com/...', 'url')}
        {field(Phone, 'Numéro de téléphone', 'contact_phone', '+229 01 95 92 70 77', 'tel')}
        {field(Mail, 'Email', 'contact_email', 'servicesclient@ols-pierreedois.com', 'email')}
        {field(MessageCircle, 'WhatsApp (format international sans espaces ni +)', 'contact_whatsapp', '22901959270077', 'tel')}

        {message && (
          <div className={`p-3 rounded-xl text-sm flex items-center gap-2 ${message.startsWith('Erreur') ? 'bg-red-50 text-red-700 border border-red-200' : 'bg-emerald-50 text-emerald-700 border border-emerald-200'}`}>
            <Check className="w-4 h-4" /> {message}
          </div>
        )}

        <div className="flex justify-end pt-2">
          <button
            onClick={save}
            disabled={saving}
            data-testid="contact-save-btn"
            className="flex items-center gap-2 px-5 py-2 bg-[#F4A340] hover:bg-[#E89534] disabled:bg-slate-200 text-white font-semibold rounded-full"
          >
            {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />} Enregistrer
          </button>
        </div>
      </div>
    </div>
  );
};

export default ContactSettings;
